import { render, staticRenderFns } from "./PhiThetaBl.vue?vue&type=template&id=50ee865a&scoped=true&"
import script from "./PhiThetaBl.vue?vue&type=script&lang=js&"
export * from "./PhiThetaBl.vue?vue&type=script&lang=js&"
import style0 from "./PhiThetaBl.vue?vue&type=style&index=0&id=50ee865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee865a",
  null
  
)

/* custom blocks */
import block0 from "./PhiThetaBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports